import { equals, always, cond } from 'ramda'

const TRUE = 1
const FALSE = 0

export const mapBoolToNum = cond([
  [equals(true), always(TRUE)],
  [equals(false), always(FALSE)],
])

export const mapNumToBool = cond([
  [equals(TRUE), always(true)],
  [equals(FALSE), always(false)],
])
